import { useQuery, UseQueryOptions } from 'react-query';

import { QueryKeys } from '.';
import { useApi } from '../../context';
import { AxiosUtils } from '../../utils';
import { Guid, FinderFeeAgreement } from '../../models';
import { CerebroApiEndpoints } from '../../utils/api';

export function useFinderFeeAgreementsQuery(
	lenderGuid?: Guid | undefined | null,
	options?:
		| Omit<UseQueryOptions<FinderFeeAgreement[], unknown, FinderFeeAgreement[], any>, 'queryKey' | 'queryFn'>
		| undefined
) {
	const api = useApi();

	return useQuery(
		QueryKeys.FinderFees.ByLender(lenderGuid),
		() =>
			AxiosUtils.getResponseData<FinderFeeAgreement[]>(
				api.get(CerebroApiEndpoints.FinderFees.ByLender(lenderGuid))
			),
		options
	);
}
